export default function loginTracking() {
	const loginCookie = document.cookie.split("; ").find((row) => row.startsWith("login_method="));

	if (loginCookie) {
		window.dataLayer.push({
			event: "login",
			method: "website",
		});
	}

	if (window.loginUserData) {
		window.dataLayer.push({
			event: "user_information",
			...window.loginUserData,
		});
	}

	if (window.loginUserId) {
		window.dataLayer.push({
			event: "user_id",
			user_id: window.loginUserId,
		});
	}

	// Delete the cookie
	document.cookie = "login_method=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

	const registerCookie = document.cookie.split("; ").find((row) => row.startsWith("register_method="));

	if (registerCookie) {
		window.dataLayer.push({
			event: "sign_up",
			method: "website",
		});

		// Delete the cookie
		document.cookie = "register_method=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
	}
}
